import wos from 'apis/wos';

import type { SaveWallPreviewPOSTData, WallPreview } from 'domains/wall_previews';

export const all = async () => {
  const { data } = await wos.get<WallPreview[]>('/wall_previews.json');
  return data;
};

export const get = async (id: number, rejectWithoutThumb: boolean = false) => {
  const { data } = await wos.get<WallPreview>(`/wall_previews/${id}.json`);

  if (rejectWithoutThumb && !data.url) {
    throw new Error('No Preview URL');
  }

  return data;
};

export const create = async (preview: SaveWallPreviewPOSTData) => {
  const { data } = await wos.post<WallPreview>('/wall_previews.json', preview);
  return data;
};

export const destroy = async (id: number) => {
  await wos.delete(`/wall_previews/${id}.json`);
};
